import * as React from 'react';
// import { useLocation, matchRoutes } from 'react-router-dom';
// import { findLast } from 'lodash-es';
// import routes from '@/config/routes';
// import HelpGuide from './HelpGuide';
// import ContentHead from './ContentHead';

type PageContentProps = {
  children: React.ReactNode;
};

export default ({ children }: PageContentProps) => {
  // const location = useLocation();
  // const [
  //   isShowHelp,
  //   hideContentHead,
  // ] = React.useMemo(
  //   () => [
  //     findLast<any>(matchRoutes(routes, location), d => d.route.help)?.route?.help,
  //     findLast<any>(matchRoutes(routes, location))?.route?.hideContentHead
  //   ],
  //   [routes, location]
  // );
  return (
    <div style={{
      minHeight: window.__MICRO_APP_ENVIRONMENT__ ? 'calc(100vh - 122px)' : 'calc(100vh - 144px)'
    }}>
      {/* {hideContentHead !== true ? <ContentHead /> : null} */}
      {/* {isShowHelp ? <HelpGuide /> : null} */}
      {children}
    </div>
  );
};
